import { useState } from 'react';
import { PortableText } from '@portabletext/react';
import { urlFor } from '../lib/sanity';
import ProductModal from './ProductModal';
import BookingButton from './BookingButton';
import { formatEventDate, formatEventTime, formatPrice } from '../lib/format';

const portableTextComponents = {
  marks: {
    link: ({ value, children }) => (
      <a href={value?.href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
  },
};

function EventRow({ event, isOpen, onToggle }) {
  const [lightboxImage, setLightboxImage] = useState(null);

  const images = event.images || [];
  const price = formatPrice(event.price, event.currency);
  const panelId = `event-panel-${event.slug}`;

  return (
    <article className={`event-row ${isOpen ? 'open' : ''}`} id={event.slug}>
      <button
        className="event-row-header"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={panelId}
      >
        <span className="event-row-date">{formatEventDate(event.startsAt)}</span>
        <span className="event-row-title">{event.title}</span>
        <span className="event-row-price">
          {event.soldOut ? 'Sold out' : price}
        </span>
        <span className="event-row-toggle" aria-hidden="true">
          {isOpen ? '−' : '+'}
        </span>
      </button>

      {isOpen && (
        <div className="event-row-panel" id={panelId}>
          {images.length > 0 && (
            <div className="event-images">
              {images.map((image, index) => (
                <button
                  key={image._key || index}
                  className="event-image-button"
                  onClick={() =>
                    setLightboxImage({
                      image: urlFor(image).width(2000).quality(85).format('webp').url(),
                      title: image.alt || event.title,
                    })
                  }
                >
                  <img
                    src={urlFor(image).width(700).quality(80).format('webp').url()}
                    alt={image.alt || event.title}
                    loading="lazy"
                  />
                </button>
              ))}
            </div>
          )}

          <dl className="event-facts">
            <div>
              <dt>When</dt>
              <dd>
                {formatEventDate(event.startsAt)}
                {formatEventTime(event.startsAt, event.endsAt) &&
                  `, ${formatEventTime(event.startsAt, event.endsAt)}`}
              </dd>
            </div>
            {event.location && (
              <div>
                <dt>Where</dt>
                <dd>{event.location}</dd>
              </div>
            )}
            {price && (
              <div>
                <dt>Price</dt>
                <dd>{price}</dd>
              </div>
            )}
          </dl>

          {event.description && (
            <div className="event-description">
              <PortableText
                value={event.description}
                components={portableTextComponents}
              />
            </div>
          )}

          <BookingButton event={event} />
        </div>
      )}

      <ProductModal product={lightboxImage} onClose={() => setLightboxImage(null)} />
    </article>
  );
}

export default EventRow;
